import { reactive, ref } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import {
  queryDefinition,
  changeStatus,
  deleteDefinition,
} from "@/api/definition";

export default function useDefinitionTable() {
  // 搜索ref
  const searchRef = ref(null);

  // 搜索条件
  const searchData = reactive({
    key: null,
    name: null,
    systemId: null,
  });

  // 表格遮罩
  const tableLoading = ref(false);

  // 表格数据
  const tableData = ref([]);

  // 表格列配置
  const columns = ref([
    {
      label: "流程定义id",
      prop: "definitionId",
    },
    {
      label: "流程key",
      prop: "processKey",
    },
    {
      label: "流程名称",
      prop: "name",
    },
    {
      label: "所属系统",
      prop: "serviceCodeText",
    },
    // {
    //   label: "表单id",
    //   prop: "formId",
    // },
    {
      label: "状态",
      prop: "isSuspendedText",
    },
  ]);

  // 分页数据
  const pages = reactive({
    page: 1,
    limit: 10,
    total: 0,
  });

  // 获取数据
  const getList = () => {
    tableLoading.value = true;
    queryDefinition({
      pageNum: pages.page,
      pageSize: pages.limit,
    })
      .then((res) => {
        tableData.value = res.data.records;
        pages.total = res.data.total;
      })
      .finally(() => {
        tableLoading.value = false;
      });
  };

  // 重置按钮
  const handleReset = () => {
    searchRef.value?.resetFields();
    getList();
  };

  // 删除
  const handleDelete = (row) => {
    ElMessageBox.confirm("确定删除此流程吗?", "警告", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "error",
    })
      .then(() => {
        deleteDefinition().then((res) => {
          if (res.code == "2000") {
            ElMessage.success("删除成功");
            getList();
          }
        });
      })
      .catch(() => {});
  };

  //激活、挂起
  const handleActivateOrHang = (row) => {
    ElMessageBox.confirm("确定变更流程状态吗?", "警告", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        changeStatus(row.definitionId).then((res) => {
          if (res.code == "2000") {
            ElMessage.success("变更成功");
            getList();
          }
        });
      })
      .catch(() => {});
  };
  return {
    searchRef,
    searchData,
    tableLoading,
    tableData,
    columns,
    pages,
    getList,
    handleReset,
    handleDelete,
    handleActivateOrHang,
  };
}
